
const LANG = document.getElementById("lessiveCheck")?.dataset.lang || "fr";

const MSG = {
  fr: { notFound: "❔ Référence non trouvée." },
  en: { notFound: "❔ Detergent not found in our database." },
  de: { notFound: "❔ Waschmittel nicht in unserer Datenbank gefunden." }
};
const I18N = {
  fr: {
    powder: "Poudre",
    liquid: "Liquide",
    compatible: "Compatible",
    inefficient: "Compatible mais inefficace",
    notCompatible: "Non compatible",
    home: "Maison"
  },
  en: {
    powder: "Powder",
    liquid: "Liquid",
    compatible: "Compatible",
    inefficient: "Compatible but inefficient",
    notCompatible: "Not compatible",
    home: "Homemade"
  },
  de: {
    powder: "Pulver",
    liquid: "Flüssig",
    compatible: "Kompatibel",
    inefficient: "Kompatibel aber ineffizient",
    notCompatible: "Nicht kompatibel",
    home: "Hausgemacht"
  }
};

const T = I18N[LANG] || I18N.fr;

/* MBDC — Lessive Checker (JS complet avec Soapix corrigé) */

(function(){
  function norm(s){
    return (s||"").toString()
      .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
      .toLowerCase().replace(/[^a-z0-9\s]/g,' ')
      .replace(/\s+/g,' ').trim();
  }
  function includes(hay, needle){ return hay.indexOf(needle)!==-1; }
  function esc(t){ return (t||"").replace(/[&<>"]/g, s=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[s])); }

 // === POUDRES COMPATIBLES ===
const POUDRES_OK = {
  "ariel propre et frais poudre": `✅ ${T.powder} — ${T.compatible}`,
  "ariel actilift poudre": `✅ ${T.powder} — ${T.compatible}`,
  "ariel original poudre": `✅ ${T.powder} — ${T.compatible}`,
  "ariel color poudre": `✅ ${T.powder} — ${T.compatible}`,
  "ariel professionnel poudre": `✅ ${T.powder} — ${T.compatible}`,
  "ariel professionnel color poudre": `✅ ${T.powder} — ${T.compatible}`,
  "ariel alpine poudre": `✅ ${T.powder} — ${T.compatible}`,
  "bonux l origine bicarbonate poudre": `✅ ${T.powder} — ${T.compatible}`,
  "carrefour expert poudre": `✅ ${T.powder} — ${T.compatible}`,
  "carrefour expert optimal clean poudre": `✅ ${T.powder} — ${T.compatible}`,
  "colruyt everyday poudre": `✅ ${T.powder} — ${T.compatible}`,
  "dash plein air poudre": `✅ ${T.powder} — ${T.compatible}`,
  "dixan total + poudre": `✅ ${T.powder} — ${T.compatible}`,
  "formil active poudre": `✅ ${T.powder} — ${T.compatible}`,
  "formil active relaxing poudre": `✅ ${T.powder} — ${T.compatible}`,
  "formil original poudre": `✅ ${T.powder} — ${T.compatible}`,
  "formil savon de marseille poudre": `✅ ${T.powder} — ${T.compatible} (parfum, pas de vrai savon)`,
  "formil withe poudre": `✅ ${T.powder} — ${T.compatible}`,
  "fraicheur poudre super u": `✅ ${T.powder} — ${T.compatible}`,
  "filetti sensitive poudre": `✅ ${T.powder} — ${T.compatible}`,
  "gama professionnel poudre": `✅ ${T.powder} — ${T.compatible}`,
  "gain aroma boost poudre": `✅ ${T.powder} — ${T.compatible}`,
  "gain oxi boost poudre": `✅ ${T.powder} — ${T.compatible}`,
  "gain original poudre": `✅ ${T.powder} — ${T.compatible}`,
  "lavex poudre": `✅ ${T.powder} — ${T.compatible}`,
  "le chat expert bicarbonate poudre": `✅ ${T.powder} — ${T.compatible}`,
  "le chat expert professionnel bicarbonate poudre": `✅ ${T.powder} — ${T.compatible}`,
  "omo professionnel poudre": `✅ ${T.powder} — ${T.compatible}`,
  "omo color care poudre": `✅ ${T.powder} — ${T.compatible}`,
  "persil universal poudre": `✅ ${T.powder} — ${T.compatible}`,
  "xtra total poudre": `✅ ${T.powder} — ${T.compatible}`,
  "daz poudre": `✅ ${T.powder} — ${T.compatible}`,
  "boni ultra poudre": `✅ ${T.powder} — ${T.compatible}`,
  "cora active poudre": `✅ ${T.powder} — ${T.compatible}`,
  "gama blanc couleurs poudre": `✅ ${T.powder} — ${T.compatible}`,
  "tandil fraicheur poudre": `✅ ${T.powder} — ${T.compatible}`,
  "dash professional poudre": `✅ ${T.powder} — ${T.compatible}`,
  "super croix poudre": `✅ ${T.powder} — ${T.compatible}`,
  "artic fraicheur poudre": `✅ ${T.powder} — ${T.compatible}`,
  "epsil sensitive poudre": `✅ ${T.powder} — ${T.compatible}`,
  "elan power fresh poudre": `✅ ${T.powder} — ${T.compatible}`,
  "auchan fresh clean poudre": `✅ ${T.powder} — ${T.compatible}`,
  "neutral sensitive poudre": `✅ ${T.powder} — ${T.compatible}`
};


  // === LIQUIDES COMPATIBLES (moins efficaces que poudres) ===
const LIQ_OK = {
  "ariel propre et frais liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "ariel actilift liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "ariel original liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "ariel color liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "ariel professionnel liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "ariel professionnel color liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "ariel alpine liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "bonux l origine bicarbonate liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "carrefour aloe vera liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "carrefour fleurs amande douce liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "carrefour expert liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "carrefour expert optimal clean liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "colruyt everyday liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "dixan mushio bianco liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "dixan lavender fresh liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "dixan color liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "dixan extreme power liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "dixan total liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "eco+ liquide": `▲ ${T.liquid} — ${T.compatible} (${T.inefficient})`,
  "epsil perfect liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "formil active liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "formil savon de marseille liquide": `▲ ${T.liquid} — ${T.compatible} (parfum, pas de vrai savon)`,
  "fraicheur liquide super u": `▲ ${T.liquid} — ${T.compatible}`,
  "filetti sensitive liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "gain aroma boost liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "gain oxi boost liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "gain original liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "lavex liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "le chat expert bicarbonate liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "le chat huiles essentielles liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "omo professionnel liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "omo color care liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "persil universal liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "super croix liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "xtra total liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "elan fresh lavender liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "tandil active liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "denk mit liquide": `▲ ${T.liquid} — ${T.compatible}`,
  "dreft liquide bleu": `▲ ${T.liquid} — ${T.compatible}`
};


  // === COMPATIBLES MAIS INEFFICACES (🟥) ===
const INEFFICACES = {
  "eco+ poudre": `🟥 ${T.compatible} — ${T.inefficient}`,
  "eco+ liquide": `🟥 ${T.compatible} — ${T.inefficient}`,
  "spee liquide": `🟥 ${T.compatible} — ${T.inefficient}`,
  "super croix liquide bresil": `🟥 ${T.compatible} — ${T.inefficient}`,
  "super croix liquide seychelles": `🟥 ${T.compatible} — ${T.inefficient}`,
  "super croix liquide bora bora": `🟥 ${T.compatible} — ${T.inefficient}`,
  "super croix liquide costa rica": `🟥 ${T.compatible} — ${T.inefficient}`,
  "neutral liquide sensitive": `🟥 ${T.compatible} — ${T.inefficient}`,
  "dreft liquide sensitive": `🟥 ${T.compatible} — ${T.inefficient}`,
  "dreft liquide noir": `🟥 ${T.compatible} — ${T.inefficient}`,
  "formil liquide violet": `🟥 ${T.compatible} — ${T.inefficient}`,
  "netto lessive liquide couleurs": `🟥 ${T.compatible} — ${T.inefficient}`,
  "netto lessive liquide fraicheur intense": `🟥 ${T.compatible} — ${T.inefficient}`,
  "netto lessive liquide agrumes": `🟥 ${T.compatible} — ${T.inefficient}`,
  "netto lessive liquide fruits exotiques": `🟥 ${T.compatible} — ${T.inefficient}`,
  "soapix lessive poudre": `🟥 ${T.compatible} — ${T.inefficient} (poudre artisanale)`
};


   // === NON COMPATIBLES (❌) ===
const NON_COMPAT = {

  // --- Skip ---
  "skip active clean poudre": `❌ ${T.powder} — ${T.notCompatible}`,
  "skip active clean liquide": `❌ ${T.liquid} — ${T.notCompatible}`,
  "skip essence de nature liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon/glycérine)`,

  // --- Liquides industriels / écolo ---
  "apta savon de marseille liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon de Marseille)`,
  "dreft eco liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon/glycérine)`,
  "ava color gel liquide": `❌ ${T.liquid} — ${T.notCompatible} (agents filmogènes / savon)`,
  "cora lessive liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon/glycérine)`,
  "ecoplan active gel liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon/glycérine)`,
  "ecoplan color gel liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon/glycérine)`,
  "mutyne lessive liquide": `❌ ${T.liquid} — ${T.notCompatible} (glycérine détectée)`,
  "lerutan lessive liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon de Marseille)`,
  "naturalia lessive liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon/glycérine)`,
  "rainett amande liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon de Marseille)`,
  "briochin peaux sensibles liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon/glycérine)`,
  "briochin savon noir liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon noir)`,
  "persil savon de marseille liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon de Marseille)`,
  "dash 2en1 liquide": `❌ ${T.liquid} — ${T.notCompatible} (agents filmogènes + savon)`,
  "omo active liquide": `❌ ${T.liquid} — ${T.notCompatible} (agents filmogènes + savon)`,
  "le chat bebe liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon/glycérine)`,
  "harmonie verte liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon/glycérine)`,
  "maison verte liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon/glycérine)`,
  "biovie liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon/glycérine)`,
  "fourmi verte savon de marseille liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon de Marseille)`,
  "marius fabre lessive liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon de Marseille)`,
  "savons arthur lavande liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon/glycérine)`,
  "l arbre vert liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon/glycérine)`,
  "l arbre vert bebe liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon/glycérine)`,
  "l arbre vert brise marine liquide": `❌ ${T.liquid} — ${T.notCompatible} (savon/glycérine)`,
  "netto lessive liquide savon de marseille": `❌ ${T.liquid} — ${T.notCompatible} (savon de Marseille)`,
  "les petits bidons sans parfum liquide": `❌ ${T.liquid} — ${T.notCompatible} (glycérine)`,
  "les petits bidons fleurs blanches liquide": `❌ ${T.liquid} — ${T.notCompatible} (glycérine)`,
  "ecodoo lessive liquide hypoallergenique": `❌ ${T.liquid} — ${T.notCompatible} (savon/glycérine)`,
  "ecodoo lessive liquide lavandin": `❌ ${T.liquid} — ${T.notCompatible} (savon de Marseille)`,
  "ecodoo lessive liquide classique": `❌ ${T.liquid} — ${T.notCompatible} (savon/glycérine)`,

  // --- Poudres ---
  "lessive lagoon poudre": `❌ ${T.powder} — ${T.notCompatible} (savon/glycérine)`,
  "apta savon de marseille poudre": `❌ ${T.powder} — ${T.notCompatible} (savon de Marseille)`,
  "miocare natural washing powder": `❌ ${T.powder} — ${T.notCompatible} (savon)`,
  "melicare lessive poudre savon": `❌ ${T.powder} — ${T.notCompatible} (savon)`,
  "briochin poudre eclatante": `❌ ${T.powder} — ${T.notCompatible} (savon)`,
  "briochin authentique poudre": `❌ ${T.powder} — ${T.notCompatible} (savon)`,
  "omo poudre active": `❌ ${T.powder} — ${T.notCompatible} (savon)`,
  "persil au savon de marseille poudre": `❌ ${T.powder} — ${T.notCompatible} (savon de Marseille)`,
  "xeor poudre": `❌ ${T.powder} — ${T.notCompatible} (savon)`,
  "ecodoo poudre linge": `❌ ${T.powder} — ${T.notCompatible} (savon/glycérine)`,

  // --- Lessives maison ---
  "lessive maison au lierre": `❌ ${T.home} — ${T.notCompatible} (savon végétal / glycérine)`,
  "lessive maison savon noir": `❌ ${T.home} — ${T.notCompatible} (savon noir)`,
  "lessive maison savon alep": `❌ ${T.home} — ${T.notCompatible} (savon d’Alep)`,

  // --- Ajouts photos ---
  "attitude baby kids liquide": `❌ ${T.liquid} — ${T.notCompatible}`,
  "les petits bidons liquide": `❌ ${T.liquid} — ${T.notCompatible}`,
  "savons arthur lessive bio lavande liquide": `❌ ${T.liquid} — ${T.notCompatible}`,
  "u nature 0 pourcent liquide": `❌ ${T.liquid} — ${T.notCompatible}`,
  "denkmit ultra sensitive poudre": `❌ ${T.powder} — ${T.notCompatible}`,
  "body nature lessive liquide": `❌ ${T.liquid} — ${T.notCompatible}`,
  "pure detergent a lessive liquide": `❌ ${T.liquid} — ${T.notCompatible}`,
  "l artisan savonnier lessive liquide": `❌ ${T.liquid} — ${T.notCompatible}`,
  "sonett lessive liquide laine soie": `❌ ${T.liquid} — ${T.notCompatible}`,
  "lucky planet lessive liquide": `❌ ${T.liquid} — ${T.notCompatible}`,
  "rainett baby liquide": `❌ ${T.liquid} — ${T.notCompatible}`,
  "bambinex lessive poudre": `❌ ${T.powder} — ${T.notCompatible} (savon/glycérine)`,
  "bionature detergent hypoallergenique liquide": `❌ ${T.liquid} — ${T.notCompatible}`

};


  // === CLASSIFY ===
  function classify(q,type){
    const n = norm(q);
    if (type==="liquide" && LIQ_OK[n]) return LIQ_OK[n];
    if (type==="poudre" && POUDRES_OK[n]) return POUDRES_OK[n];
    if (INEFFICACES[n]) return INEFFICACES[n];
    if (NON_COMPAT[n]) return NON_COMPAT[n];

    // recherche par mot-clé
    let found=[];
    for(const [k,v] of Object.entries({...POUDRES_OK,...LIQ_OK,...INEFFICACES,...NON_COMPAT})){
      if(includes(k,n)) found.push(v+" — ("+k+")");
    }
    return found.length ? found.join("<br>") : MSG[LANG].notFound;


  }

  // === BIND UI ===
  document.getElementById("lc-check").addEventListener("click",()=>{
  const q=document.getElementById("lc-input").value;
  const type=document.getElementById("lc-type").value;
  const res=classify(q,type);

  const out = document.getElementById("lc-out");
  out.classList.remove("has-result");
  out.innerHTML = res;
  out.classList.add("has-result");
});

})();
